export const SORT_ORDERS = {
  RECOMMENDED: 'RECOMMENDED',
  LOWEST_PRICE: 'LOWEST_PRICE',
  HIGHEST_PRICE: 'HIGHEST_PRICE',
  RATING: 'RATING',
  GUEST_RATING: 'GUEST_RATING',
  DEFAULT: 'RECOMMENDED',
};

export const SORT_ORDER_TO_CA_KEY = {
  [SORT_ORDERS.RECOMMENDED]: 'vingRecSortLabel',
  [SORT_ORDERS.LOWEST_PRICE]: 'priceAscSortLabel',
  [SORT_ORDERS.HIGHEST_PRICE]: 'priceDescSortLabel',
  [SORT_ORDERS.RATING]: 'ratingDescSortLabel',
  [SORT_ORDERS.GUEST_RATING]: 'guestRatingDescSortLabel',
};

export const SORT_ORDER_FIELD = {
  RECOMMENDED: { field: 'originalSortOrder' },
  LOWEST_PRICE: { field: 'price' },
  HIGHEST_PRICE: { field: 'price', descending: true },
  RATING: { field: 'rating', descending: true },
  GUEST_RATING: { field: 'guestRating', descending: true },
};

export const FLIGHT_LIST_SORT_ORDERS = {
  RECOMMENDED: 'RECOMMENDED',
  LOWEST_PRICE: 'LOWEST_PRICE',
  FASTEST: 'FASTEST',
};

export const CRUISE_LIST_SORT_ORDERS = {
  DEPARTURE_DATE: 'DEPARTURE_DATE',
  LOWEST_PRICE: 'LOWEST_PRICE',
  HIGHEST_PRICE: 'HIGHEST_PRICE',
  DURATION: 'DURATION',
};

export const PACKAGE_PLUS_LIST_SORT_ORDERS = {
  RECOMMENDED: 'RECOMMENDED',
  LOWEST_PRICE: 'LOWEST_PRICE',
  HIGHEST_PRICE: 'HIGHEST_PRICE',
};
